export default class DistanceToBottomOption {
  constructor(readonly label: string, readonly value: number) {}
}

export const DISTANCE_TO_BOTTOM_OPTIONS = {
  _160CM: new DistanceToBottomOption('160 cm', 160),
  _210CM: new DistanceToBottomOption('210 cm', 210),
  CUSTOM: new DistanceToBottomOption('Aangepast', null)
};

export const DISTANCE_TO_BOTTOM_OPTIONS_ARRAY = Object.values(
  DISTANCE_TO_BOTTOM_OPTIONS
);

export function compareDistanceToBottomOptions(
  o1: DistanceToBottomOption,
  o2: DistanceToBottomOption
): boolean {
  return (
    (o1 == null && o2 == null) ||
    (o1 != null && o2 != null && o1.value === o2.value)
  );
}
